import { Component, OnInit } from '@angular/core';
import { MetatagService } from 'src/app/services/metatag.service';
import { SectionService } from 'src/app/services/section.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {

  isLoading = true;
  section: any;

  constructor(
    protected metatagService: MetatagService,
    protected sectionService: SectionService,
  ) { }

  ngOnInit() {
    this.metatagService.configSlug('terms');
    this.loadData();
  }

  loadData() {
    this.sectionService.fetchTerms().toPromise().then(data => {
      this.isLoading = false;
      if (!data.success) {
        return;
      }
      this.section = data.response;
    });
  }
}
